export const format = (str: string, args?: StringFormatArgs, autoEscape = true) =>
{
    if (args != null)
    {
        return str.replace(/\{([a-zA-Z0-9_]+)\}/g, (match, key) => 
        {
            if (args.hasOwnProperty(key))
            {
                let value = args[key];
                if (value != null)
                {
                    let strValue = value.toString();
                    return autoEscape ? escape(strValue) : strValue;
                }
                else
                {
                    return '';
                }
            } 
            else 
            {
                return match;
            }
        });
    }
    else
    {
        return str;
    }
}

export const escape = (text: string): string =>
{
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
      };
      
    return String(text).replace(/[&<>"'`=\/]/g, function (s) {
        return entityMap[s];
    });
};

export function pad(str: string, size: number) {
    let s = new String(str).toString();
    while (s.length < size) s = '0' + s;
    return s;
}

export interface StringFormatArgs
{
    [key: string]: number | string;
}
